import fullAtlas from "../services/fullAtlas";
import fullBanking from "../services/fullBanking";
import fullAuth from "../services/fullAuth";
import CryptoJS from "crypto-js";

export async function authProject(arg) {
  // const data = arg;
  const data = {
    secretKey: await getItem("companyId"),
    boundId: "br.com.atlas",
  };

  const PROJECT = getItem("tk-project");
  const USER = getItem("tk-user");

  if (PROJECT) {
    sessionStorage.removeItem("tk-project");
  }
  if (USER) {
    sessionStorage.removeItem("tk-user");
  }

  const authProject = await fullAuth.post("full-auth/tkProject", data);

  setItem(
    authProject.data.data.type.toLowerCase(),
    authProject.data.data.token
  );

  return authProject;
}

export function getAllItems() {
  const storageItems = sessionStorage.getItem("crypto");
  const response = JSON.parse(storageItems);

  return response;
}

export async function removeItem(arg) {
  const name = sessionStorage.getItem("crypto");
  if (name === null) {
    return null;
  } else {
    const decrypted = CryptoJS.AES.decrypt(
      JSON.parse(name),
      "CAmoNChYLaPHalvenTATeS"
    ).toString(CryptoJS.enc.Utf8);
    const remove = JSON.parse(decrypted);
    delete remove[arg];

    const data = { ...remove };
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      "CAmoNChYLaPHalvenTATeS"
    ).toString();
    sessionStorage.setItem("crypto", JSON.stringify(encrypted));
  }
}

export async function setItem(name, item) {
  const storageItemValue = { [name]: item };
  let storageValues = await getAllItems();

  if (storageValues === null) {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(storageItemValue),
      "CAmoNChYLaPHalvenTATeS"
    ).toString();
    sessionStorage.setItem("crypto", JSON.stringify(encrypted));
  } else {
    const decrypted = CryptoJS.AES.decrypt(
      storageValues,
      "CAmoNChYLaPHalvenTATeS"
    ).toString(CryptoJS.enc.Utf8);
    const newDecrypted = JSON.parse(decrypted);
    const data = { ...newDecrypted, ...storageItemValue };

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      "CAmoNChYLaPHalvenTATeS"
    ).toString();
    sessionStorage.setItem("crypto", JSON.stringify(encrypted));
  }
}

export function getItem(arg) {
  const name = sessionStorage.getItem("crypto");
  if (name === null) {
    return null;
  } else {
    const decrypted = CryptoJS.AES.decrypt(
      JSON.parse(name),
      "CAmoNChYLaPHalvenTATeS"
    ).toString(CryptoJS.enc.Utf8);
    const teste = JSON.parse(decrypted);

    return teste[arg];
  }
}

export async function checkIndicationCode(arg) {
  const { id } = arg;
  const checkUser = await fullAtlas.get(`/affiliate-code/${id}`);

  return checkUser;
}

export async function checkUser(arg) {
  const { data } = arg;
  const checkUser = await fullAuth.post(`full-auth/checkUser`, data);

  return checkUser;
}

export async function validToken(arg) {
  const data = arg;
  const validToken = await fullAuth.post(`full-auth/validToken`, data);

  return validToken;
}

export async function validUser(arg) {
  const { data } = arg;
  const checkUser = await fullAuth.post(`full-auth/validUser`, data);

  return checkUser;
}

export async function getEmailUser(arg) {
  const { email } = arg;
  const response = await fullBanking.get(`/onboarding/accounts/email/${email}`);

  return response;
}

export async function getTaxIdUser(arg) {
  const { taxId } = arg;
  const response = await fullBanking.get(`/onboarding/accounts/taxId/${taxId}`);

  return response;
}

export async function getPhoneUser(arg) {
  const { phone } = arg;
  const response = await fullBanking.get(`/onboarding/accounts/phone/${phone}`);

  return response;
}

export async function createAccountShort(arg) {
  const { data } = arg;
  const response = await fullBanking.post("/onboarding/account/short", data);

  return response;
}

export async function createAccountPJ(arg) {
  const { data } = arg;
  const response = await fullBanking.post("/onboarding/pj/create", data);

  return response;
}

export async function requestToken(arg) {
  const { userId, data } = arg;
  const reqToken = await fullAuth.post(
    `full-auth/requestToken/${userId}`,
    data
  );

  return reqToken;
}

export async function validateToken(arg) {
  const { userId, data } = arg;
  const validToken = await fullAuth.post(
    `full-auth/validateToken/${userId}`,
    data
  );

  return validToken;
}

export async function validateTokenIB(arg) {
  const { data } = arg;
  const validToken = await fullAuth.post(`full-auth/validateTokenIB`, data);

  setItem(validToken.data.data.type.toLowerCase(), validToken.data.data.token);

  return validToken;
}

export async function getDns(arg) {
  const params = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.get(`/product-dns/dns`, { params });

  return response;
}

export async function getPaymentUser(arg) {
  const params = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.get(`/paymentUser`, { params });

  return response;
}

export async function getPaymentGroup(arg) {
  const params = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.get(`/payment-group`, { params });

  return response;
}

export async function createPurchase(arg) {
  const { data } = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.post(`/purchase`, data);

  return response;
}
export async function cancelPurchase(arg) {
  const { userId } = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.post(`/purchase/${userId}/cancel`);

  return response;
}
export async function getPurchase(arg) {
  const { userId } = arg;
  // const response = await lambdaatlas.get(`/product-dns/dns`, { params });
  const response = await fullAtlas.post(`/purchase/${userId}`);

  return response;
}

export const formatAmount = (val) => {
  const currency = (String(val) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

  return currency;
};

export const labelsPerFrequency = {
  YEARLY: "/ ano",
  SEMIANNUALLY: "/ semestre",
  QUARTERLY: "/ trimestre",
  MONTHLY: "/ mês",
};

export const labelsFrequency = {
  YEARLY: "anual",
  SEMIANNUALLY: "semestral",
  QUARTERLY: "trimestral",
  MONTHLY: "mensal",
};

export const labelsPaymentMethod = {
  BOLETO: "Boleto",
  PIX: "PIX",
  // CREDIT_CARD: "Cartão de crédito",
  DEBIT: "Débito em conta",
};
